import {
  AddPaymentMethods,
  PaymentActionType,
} from "../manageWallet/addPaymentMethods/AddPaymentMethods";
import { parsePaymentMethod } from "utility/paymentMethod";
import {
  getEnumByValue,
  isExpired,
  PAYMENT_METHOD_TYPE,
  renderConditionalProp,
} from "utility";
import { ACH, CARD } from "constants/common";
import classes from "./PayByText.module.scss";
import { UseInput } from "hooks";
import { PaymentMethodConfiguration } from "store/config";
import { PaymentMethod } from "store/paymentMethods/paymentMethods-state";
import { AccountRestrictions } from "store/account/account-state";

interface PaymentMethodSectionProps {
  paymentMethods: PaymentMethod[];
  paymentMethodTypesEnabled: { [key: string]: PaymentMethodConfiguration };
  restrictions: AccountRestrictions;
  paymentMethodId: UseInput;
  paymentMethodSelection: UseInput;
  isEnabled: boolean;
  t: (key: string, options?: any) => string;
  handleNewPaymentMethodAdded: (newMethod: any) => void;
  buttonClick: any;
  updateButtonClickFromChild: (fn: (prev: any) => any) => void;
}

export const PaymentMethodSection = ({
  paymentMethods,
  paymentMethodTypesEnabled,
  restrictions,
  paymentMethodId,
  paymentMethodSelection,
  isEnabled,
  t,
  handleNewPaymentMethodAdded,
  buttonClick,
  updateButtonClickFromChild,
}: PaymentMethodSectionProps) => {
  const renderPaymentMethods = (paymentMethods: PaymentMethod[]) => {
    return paymentMethods
      .filter((single) => !isExpired(single.expirationDate))
      .map((single: PaymentMethod, i: number) => {
        const { title } = parsePaymentMethod(single);
        const methodType = getEnumByValue(
          PAYMENT_METHOD_TYPE,
          single.paymentMethodType!
        );
        let paymentTypeRestricted = false;
        switch (methodType) {
          case ACH:
            paymentTypeRestricted = restrictions.achRestricted;
            break;
          case CARD:
            paymentTypeRestricted = restrictions.cardRestricted;
            break;
          default:
            break;
        }

        if (
          methodType !== null &&
          paymentMethodTypesEnabled[methodType] &&
          !paymentTypeRestricted
        ) {
          return (
            <ft-list-item
              key={i}
              {...renderConditionalProp(
                String(paymentMethodId.value) === String(single.id),
                "selected"
              )}
              value={String(single.id).trim()}
            >
              {title}
            </ft-list-item>
          );
        }
        return null;
      });
  };

  return (
    <div className={classes.SectionWrapper}>
      <p className={classes.Heading}>
        {t("payment_next:choose_payment_method")}
      </p>
      <span className={classes.DialogLine}>
        {t("payment_next:processing_fee")}
      </span>
      {paymentMethods && paymentMethods[0] ? (
        <>
          <ft-formfield label={`${t("common:saved_payment_methods")}`}>
            <ft-radio
              {...renderConditionalProp(
                paymentMethodSelection.value === "saved_method",
                "checked"
              )}
              onClick={paymentMethodSelection.valueChangeHandler}
              name="payment-method-selection"
              value="saved_method"
              {...renderConditionalProp(!isEnabled, "disabled")}
            ></ft-radio>
          </ft-formfield>
          {paymentMethods &&
            paymentMethods.length > 0 &&
            paymentMethodSelection.value === "saved_method" && (
              <ft-select
                ref={paymentMethodId.ref}
                validationMessage={t("common:field_not_empty")}
                required
                value={String(paymentMethodId.value ?? "")}
                onClick={paymentMethodId.valueChangeHandler}
                onBlur={paymentMethodId.inputBlurHandler}
                outlined
                label={t("payment_next:choose_payment_method")}
                id="payment-method"
                class={classes.SavedPaymentMethod}
                {...renderConditionalProp(!isEnabled, "disabled")}
              >
                {paymentMethods ? renderPaymentMethods(paymentMethods) : null}
              </ft-select>
            )}
        </>
      ) : null}
      <ft-formfield label={`${t("payment_next:new_payment_method")}`}>
        <ft-radio
          {...renderConditionalProp(
            paymentMethodSelection.value === "new_method",
            "checked"
          )}
          onClick={paymentMethodSelection.valueChangeHandler}
          name="payment-method-selection"
          value="new_method"
          {...renderConditionalProp(!isEnabled, "disabled")}
        ></ft-radio>
      </ft-formfield>
      {paymentMethodSelection.value === "new_method" && (
        <AddPaymentMethods
          inlineView={true}
          paymentActionType={PaymentActionType.SAVE_AND_PAY_LATER}
          paymentHandler={handleNewPaymentMethodAdded}
          buttonClick={buttonClick}
          updateButtonClick={updateButtonClickFromChild}
        />
      )}
    </div>
  );
};
